// src/CustomLayout.js
import * as React from 'react';
import { Layout, AppBar, Title } from 'react-admin';
import CustomMenu from './CustomMenu';
import { Box } from '@mui/material'; // لاستخدام Spacer

// --- 1. إنشاء شريط علوي مخصص ---
const CustomAppBar = (props) => (
    <AppBar {...props} sx={{ 
        // هذا يمنع الشريط العلوي من تغطية القائمة الجانبية
        // (إصلاح لمشكلة شائعة في react-admin)
        '& .RaAppBar-toolbar': {
            paddingLeft: '8px', 
        },
    }}>
        <Box flex="1" display="flex" justifyContent="space-between" alignItems="center">
            {/* عنوان الصفحة (مثل "Dashboard" أو "Users") */}
            <Title />

        </Box>
    </AppBar>
);

// --- 2. تمرير الشريط العلوي المخصص إلى المكون الرئيسي ---
export const CustomLayout = (props) => (
    <Layout 
        {...props} 
        menu={CustomMenu} 
        appBar={CustomAppBar} // <-- **الإضافة الجديدة**: استخدام الشريط المخصص
    />
);